export * from './generic-list-item.interface';
